import { render } from "./AddTaskCard.vue?vue&type=template&id=359e58ba&scoped=true"
import script from "./AddTaskCard.vue?vue&type=script&lang=js"
export * from "./AddTaskCard.vue?vue&type=script&lang=js"

import "./AddTaskCard.vue?vue&type=style&index=0&id=359e58ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359e58ba"]])

export default __exports__